import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DropdownToggleWrapper from '../../dropdown/dropdown-toggle-wrapper';
import InputChip from './input-chip';

import './text-input.scss';

const ChippedInput = props => {
  const {
    name,
    value,
    onChange,
    subLabel,
    options,
    optionsMap,
    disableManualInput,
    chipType,
    maxlength,
  } = props;
  const [inputValue, setInputValue] = useState('');
  const [dropdownSelectedItems, setDropdownSelectedItems] = useState([]);

  const handleValueChange = value => {
    onChange({ target: { value, name } });
  };

  const handleChipify = e => {
    if (!inputValue) return;

    const newValue = inputValue.trim();

    handleValueChange([...value, newValue]);
    setInputValue('');
  };

  const handleKeyUp = e => {
    if (e.keyCode === 13) {
      e.preventDefault();
      handleChipify(e);
    }
  };

  const handleRemove = idx => {
    const newValues = value.slice();
    newValues.splice(idx, 1);
    setDropdownSelectedItems(dropdownSelectedItems.filter(item => newValues.includes(item.value)));
    handleValueChange(newValues);
  };

  const handlePaste = e => {
    e.preventDefault();
    const textValue = e.clipboardData.getData('Text');
    const newValue = textValue.trim().substring(0, 512);

    handleValueChange([...value, newValue]);
    setInputValue('');
  };

  return (
    <div className="chipped-input-container">
      <div className="chipped-input">
        {value.map((item, idx) => {
          const isProductCategory = ['google_category', 'merchant_category'].includes(chipType);
          let chipText = '';
          if (optionsMap && optionsMap[item]) {
            chipText = optionsMap[item];
          } else if (isProductCategory) {
            const itemCategories = item.split('>');
            chipText = itemCategories[itemCategories.length - 1].trim();
          } else {
            chipText = item;
          }

          return (
            <InputChip
              key={item}
              text={chipText}
              toolTipText={isProductCategory ? item : undefined}
              size="text"
              actionIcon="x"
              onRemove={() => handleRemove(idx)}
            />
          );
        })}
        <DropdownToggleWrapper
          items={options}
          multi={true}
          searchable={true}
          confirmPrompt={true}
          selected={dropdownSelectedItems}
          onSelect={selected => {
            setDropdownSelectedItems(selected);
            const selectedValues = selected
              .map(item => item.value)
              .filter(item => !value.includes(item));
            handleValueChange([...value, ...selectedValues]);
          }}
          matchToggleWidth={true}
        >
          <input
            type="text"
            value={inputValue}
            onChange={e => {
              if (!disableManualInput) {
                setInputValue(e.target.value);
              }
            }}
            onBlur={handleChipify}
            onPaste={handlePaste}
            onKeyUp={handleKeyUp}
            onKeyDown={e => {
              if (e.keyCode === 13) e.preventDefault();
            }}
            onSubmit={e => e.preventDefault()}
            maxlength={maxlength}
          />
        </DropdownToggleWrapper>
      </div>
      <div>{subLabel}</div>
    </div>
  );
};

ChippedInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  subLabel: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })),
  disableManualInput: PropTypes.bool,
  chipType: PropTypes.string,
};

ChippedInput.defaultProps = {
  name: '',
  value: [],
  onChange: () => {},
  subLabel: '',
  options: null,
  disableManualInput: false,
  chipType: '',
};

export default ChippedInput;
